import React from "react";
import "./Header.css";

export function Header() {
  return <p className="title">Machine ToDo!</p>;
}
